import { routes } from '../config/api_routes';
export const zomatoOrderService = {
    getOrders: (filters,options) => window.axios.post(routes.getZomatoOrdersApi, filters,options),
    getOrdersCount: (filters) => window.axios.post(routes.getZomatoOrdersCountApi,filters),
    exportZomatoOrders: (filters) => window.axios.post(routes.exportZomatoOrdersApi, filters),
}